import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GetPubsDTO} from 'typescript/dto/pubsDto';
import {IPageEditorUnassign} from 'typescript/interfaces/PageEditorUnassign';
import PubPage from 'typescript/models/PubPage';

export type PubFilters = Required<GetPubsDTO>;

interface IState {
  pubs: {list: PubPage[]; totalCount: number; totalPages: number};
  totalPages: number;
  pageEditorUnassignData: IPageEditorUnassign | null;
  filters: PubFilters;
}

export const pubsPerPage = 15;

const initialState: IState = {
  pubs: {list: [], totalCount: 0, totalPages: 1},
  totalPages: 0,
  pageEditorUnassignData: null,
  filters: {page: 1, perPage: pubsPerPage, name: '', direction: 'asc', column: 'name'},
};

const pubSlice = createSlice({
  name: 'pubs',
  initialState,
  reducers: {
    setPubsAC: (state, action: PayloadAction<IState['pubs']>) => {
      state.pubs = action.payload;
    },
    setTotalPagesAC: (state, action: PayloadAction<IState['totalPages']>) => {
      state.totalPages = action.payload;
    },
    setUpdatedPubAC: (state, action: PayloadAction<PubPage>) => {
      state.pubs = {
        ...state.pubs,
        list: state.pubs.list.map((pub: PubPage) => (pub.id === action.payload.id ? action.payload : pub)),
      };
    },
    setPageEditorUnassignDataAC: (state, action: PayloadAction<IState['pageEditorUnassignData']>) => {
      state.pageEditorUnassignData = action.payload;
    },
    setPubPageFiltersAC: (state, action: PayloadAction<IState['filters']>) => {
      state.filters = action.payload;
    },
  },
});

export default pubSlice;

export const {setPubsAC, setTotalPagesAC, setUpdatedPubAC, setPageEditorUnassignDataAC, setPubPageFiltersAC} =
  pubSlice.actions;
